import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/nl';

import CoreLink from '../../../CoreLink';
import type { SearchForumCategoriesHit } from '../../types';

moment.locale('nl');

export interface SearchForumCategoriesResultsHitProps {
  hit: SearchForumCategoriesHit;
}

const SearchForumCategoriesResultsHit: React.FC<SearchForumCategoriesResultsHitProps> = (props) => {
  const { hit } = props;
  const { t } = useTranslation();

  const url = hit.url[0];
  const tid = hit.tid[0];
  const name = hit.name[0];
  const postCount = hit.post_count[0];
  const commentCount = hit.comment_count[0];
  const latestCommentTimestamp = hit.latest_comment_timestamp[0];
  const latestCommentDate = latestCommentTimestamp && moment(latestCommentTimestamp * 1000);

  return (
    <div key={tid} className="SearchForumCategory">
      <CoreLink href={url} className="u-word-break SearchForumCategory__title">
        {name}
      </CoreLink>
      <footer className="SearchForumCategory__footer">
        <div className="SearchForumCategory__label">
          <i className="icon icon-clock" />
          <span className="SearchForumCategory__label__text">
            {t('pages.forum.categories.labels.last_response')}
          </span>
          <span>
            {latestCommentTimestamp !== 0 && commentCount !== 0
              ? latestCommentDate.fromNow()
              : t('pages.forum.categories.labels.no_response')}
          </span>
        </div>


        <div className="SearchForumCategory__label">
          <i className="icon icon-conversation" />
          <span className="SearchForumCategory__label__text">
            {t('pages.forum.categories.labels.number_of_posts')}
          </span>
          <span>{postCount}</span>
        </div>


        <div className="SearchForumCategory__label">
          <i className="icon icon-balloon" />
          <span className="SearchForumCategory__label__text">
            {t('pages.forum.categories.labels.number_of_comments')}
          </span>
          <span>{commentCount}</span>
        </div>

      </footer>
    </div>
  );
};

export default SearchForumCategoriesResultsHit;
